import { createContext, useContext } from 'react'

export type TrackAction = (action: string, value?: string) => void

/**
 * Отправка действий калькулятора. Через контекст, а не пропами: события шлют
 * и вкладки, и шторка рецепта, которая лежит через два уровня, а заводить
 * второй `usePageAnalytics` нельзя — он отправит лишний заход и заведёт свой
 * таймер времени.
 */
export const CalculatorAnalyticsContext = createContext<TrackAction>(() => {})

export const useTrackAction = (): TrackAction =>
  useContext(CalculatorAnalyticsContext)

/**
 * Коды событий держим в одном месте: их читают в отчётах, и разъехавшееся
 * написание там уже не починить задним числом.
 */
export const CALC_EVENTS = {
  /** Открыли расчёт по рецепту. Значение — card_id. */
  openRecipeCost: 'open_recipe_cost',
  /** В расчёте есть цены на всё. Значение — card_id. */
  costComplete: 'cost_complete',
  /** Цен не хватает. Значение — `card_id__сколько не хватает`. */
  costIncomplete: 'cost_incomplete',
  /** Завели цену продукта на вкладке продуктов. Значение — ingredient_id. */
  saveProduct: 'save_product',
  /** Добавили рецепт себе. Значение — card_id. */
  saveRecipe: 'save_recipe',
  /** Вписали цену не выходя из рецепта. Значение — ingredient_id. */
  addPriceFromRecipe: 'add_price_from_recipe',
} as const
